import React from 'react';
import EventCard from './EventCard';

const EventListView = ({ events, onApply, onInquiry, onViewDetails }) => {
  const hasInquiry = typeof onInquiry === 'function';
  if (events.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
        <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
          <span className="text-3xl">🏃</span>
        </div>
        <h3 className="text-lg font-semibold text-foreground mb-2">검색 결과가 없습니다</h3>
        <p className="text-sm text-muted-foreground caption">다른 필터 조건으로 다시 검색해보세요</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between px-6 py-4">
        <h2 className="text-lg font-semibold text-foreground">검색 결과 {events.length}개</h2>
      </div>
      <div className="space-y-4 px-6 pb-6">
        {events.map((event) => (
          <EventCard
            key={event.id}
            event={event}
            onApply={() => onApply(event.id)}
            onInquiry={hasInquiry ? () => onInquiry(event.id) : undefined}
            onViewDetails={() => onViewDetails(event.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default EventListView;
